import { IFormTemplateState } from '@/store/form-template';
import { IFormTemplateGetters } from './getters.types';
import {
  IFormTemplate,
  FormTemplate,
  IFormTemplateData,
  FormField,
  IFormField,
  IFormFieldData,
  FormFieldOptionTodo,
  IFormFieldOptionTodo,
  IFormFieldOptionTodoData,
  FormFieldOptionTodoTemplate,
  IFormFieldOptionTodoTemplate,
  IFormFieldOptionTodoTemplateData,
  FormFieldOption,
  IFormFieldOption,
  IFormSectionData,
  FormTemplateStateEnum
} from '@/models';

export const getters: IFormTemplateGetters = {
  getFormTemplates(state: IFormTemplateState): IFormTemplate[] {
    return state.formTemplates.map(
      (data: IFormTemplateData) => new FormTemplate(data)
    );
  },

  getFormTemplateById: (state: IFormTemplateState) => (
    id: number
  ): IFormTemplate | undefined => {
    const data = state.formTemplates.find(
      (formTemplate: IFormTemplateData) => formTemplate.id === id
    );
    if (!data) {
      return undefined;
    }

    return new FormTemplate(data);
  },

  getPublishedFormTemplates(state: IFormTemplateState): IFormTemplate[] {
    return state.formTemplates
      .filter(template => template.state == FormTemplateStateEnum.Published)
      .map((data: IFormTemplateData) => new FormTemplate(data));
  },

  //fields
  getFormFields(state: IFormTemplateState): IFormField[] {
    return state.formFields.map((data: IFormFieldData) => new FormField(data));
  },

  getFormFieldById: (state: IFormTemplateState) => (
    id: number
  ): IFormField | undefined => {
    const data = state.formFields.find(
      (formFields: IFormFieldData) => formFields.id === id
    );

    if (!data) {
      return undefined;
    }

    return new FormField(data);
  },

  getFormFieldsOptionsByTemplateId: (
    state: IFormTemplateState,
    getters: any
  ) => (id: number): IFormFieldOption[] => {
    const fieldsOptions = [] as IFormFieldOption[];

    (getters.getFormTemplateById(id).sections! as IFormSectionData[]).forEach(
      section => {
        section.section_fields.forEach(section_field => {
          const fieldOptions = (section_field.field_template as IFormFieldData).options!.map(
            option => new FormFieldOption(option)
          );

          if (fieldOptions.length > 0) {
            fieldsOptions.push(...fieldOptions);
          }
        });
      }
    );

    return fieldsOptions;
  },

  getFormFieldsOptionByTemplateIdAndOptionId: (
    state: IFormTemplateState,
    getters: any
  ) => (templateId: number, optionId: number): IFormFieldOption | undefined => {
    const data = getters
      .getFormFieldsOptionsByTemplateId(templateId)
      .find((formOption: IFormFieldOption) => formOption.id === optionId);

    if (!data) {
      return undefined;
    }

    return new FormFieldOption(data);
  },

  //todos
  getFormFieldOptionTodos(state: IFormTemplateState): IFormFieldOptionTodo[] {
    return state.formFieldOptionTodos.map(
      (data: IFormFieldOptionTodoData) => new FormFieldOptionTodo(data)
    );
  },

  getFormFieldOptionTodoById: (state: IFormTemplateState) => (
    id: number
  ): IFormFieldOptionTodo | undefined => {
    const data = state.formFieldOptionTodos.find(
      (formFields: IFormFieldOptionTodoData) => formFields.id === id
    );

    if (!data) {
      return undefined;
    }

    return new FormFieldOptionTodo(data);
  },

  getOptionTodosBySectionFieldAndOptionId: (state: IFormTemplateState) => (
    sectionId: number,
    fieldId: number
  ): IFormFieldOptionTodo[] => {
    const filteredTodos = state.formFieldOptionTodos.filter(
      (formFields: IFormFieldOptionTodoData) =>
        formFields.section_field === sectionId &&
        formFields.field_option == fieldId
    );

    return filteredTodos.map(
      (data: IFormFieldOptionTodoData) => new FormFieldOptionTodo(data)
    );
  },

  //todo templates
  getFormTodoTemplates(
    state: IFormTemplateState
  ): IFormFieldOptionTodoTemplate[] {
    return state.formTodoTempates.map(
      (data: IFormFieldOptionTodoTemplateData) =>
        new FormFieldOptionTodoTemplate(data)
    );
  },

  getFormTodoTemplateById: (state: IFormTemplateState) => (
    id: number
  ): IFormFieldOptionTodoTemplate | undefined => {
    const data = state.formTodoTempates.find(
      (formTemplate: IFormFieldOptionTodoTemplateData) => formTemplate.id === id
    );
    if (!data) {
      return undefined;
    }

    return new FormFieldOptionTodoTemplate(data);
  }
};
